"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5.84 7.133a.5.5 0 0 0-.68.734l4.298 3.967-4.312 4.312a.5.5 0 0 0 .708.708l4.34-4.34.789.727a1.5 1.5 0 0 0 2.034 0l.79-.728 4.34 4.34a.5.5 0 0 0 .707-.707l-4.312-4.312 4.297-3.967a.5.5 0 0 0-.678-.734l-5.822 5.373a.5.5 0 0 1-.678 0z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5.5 5A2.5 2.5 0 0 0 3 7.5v9A2.5 2.5 0 0 0 5.5 19h13a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 18.5 5zM4 7.5A1.5 1.5 0 0 1 5.5 6h13A1.5 1.5 0 0 1 20 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 16.5z"
  })]
}), 'Email');
//# sourceMappingURL=index.js.map